module.exports = __webpack_public_path__ + "static/media/corpu_doc3.b1661f49.jpg";